import styled from 'styled-components'

export const ExperimentEndPageStyle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const ExperimentEndPageContentStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  width: 55%;
  gap: 3em;

  h1 {
    margin: 0;
  }

  p {
    text-align: center;
    margin-top: 0;
  }

  #content {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5em;
  }
`
